import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

import Heading from '@/ui/components/Heading';
import Tooltip from '@/ui/components/Tooltip';

import { Props } from './types';

const ListCardHeading = ({
  headingBorder,
  headingHref,
  headingIcon,
  headingIconClassName,
  headingIconTooltip,
  title,
  subtitle
}: Props) => {
  const heading = <Heading text={title} value={4} />;

  return (
    <div className="flex items-center mb-1 min-w-0">
      {headingIcon && typeof headingIcon === 'string' ? (
        <img
          className={`inline-block h-10 w-10 rounded-full mr-2 ${headingIconClassName}`}
          src={headingIcon}
          alt="transaction merchant icon"
        />
      ) : (
        headingIcon && (
          <Tooltip tooltipContent={headingIconTooltip} disabled={!headingIconTooltip}>
            <div className="flex items-center justify-center w-10 h-10 rounded-full bg-neutral-100 mr-2">
              <FontAwesomeIcon
                className={`text-2xl ${headingIconClassName || ''}`}
                icon={headingIcon as IconProp}
              />
            </div>
          </Tooltip>
        )
      )}

      <hgroup
        className={`inline-flex flex-col min-w-0 ${headingBorder ? 'border-b border-gray-200' : ''}`}>
        {headingHref ? (
          <Link className="hover:underline flex items-center" to={headingHref}>
            {heading}
            <FontAwesomeIcon icon={faChevronRight} className="ml-1 text-base shrink-0" />
          </Link>
        ) : (
          <>{heading}</>
        )}

        {subtitle && <p className="text-sm font-semibold text-gray-600">{subtitle}</p>}
      </hgroup>
    </div>
  );
};

export default ListCardHeading;
